/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryDetails
 */
export interface ProposalSummaryDetails {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryDetails
     */
    proposalNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryDetails
     */
    proposalDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryDetails
     */
    proposalInApplicationOrSigning: boolean;
}

/**
 * Check if a given object implements the ProposalSummaryDetails interface.
 */
export function instanceOfProposalSummaryDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalNumber" in value;
    isInstance = isInstance && "proposalDate" in value;
    isInstance = isInstance && "proposalInApplicationOrSigning" in value;

    return isInstance;
}

export function ProposalSummaryDetailsFromJSON(json: any): ProposalSummaryDetails {
    return ProposalSummaryDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalNumber': json['ProposalNumber'],
        'proposalDate': (new Date(json['ProposalDate'])),
        'proposalInApplicationOrSigning': json['ProposalInApplicationOrSigning'],
    };
}

export function ProposalSummaryDetailsToJSON(value?: ProposalSummaryDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalNumber': value.proposalNumber,
        'ProposalDate': (value.proposalDate.toISOString()),
        'ProposalInApplicationOrSigning': value.proposalInApplicationOrSigning,
    };
}

